// extracted by css-extract-rspack-plugin
export default {"icon":"h_UL3c2weRkMk43g"};